export default {
    ahpraNumber: /^(?:MED|PHA|NMW|ZZZ)\d{10}$/,
    password: /^(?=.*\d)(?=.*[a-z]).{6,}$/,
    passwordDigits: /^(?=.*\d).+$/,
    passwordSpecialCharacters: /(?=.*[!"#$%&”()*\-<.{}?[\]@^~])/,
    passwordLowercase: /^(?=.*[a-z]).+$/,
    passwordUppercase: /^(?=.*[A-Z]).+$/,
    passwordLength: /^.{8,}$/,
    postcode: /^[023-5678]{1}[0-9]{3}$/,
};
